function joinPaths(...segments) {
  return [...segments].join('/').replace(/\/+/g, '/');
}

export default function generateParentPath(parent, path) {
  if (parent.parent) {
    return generateParentPath(parent.parent, joinPaths(parent.path, path));
  }

  return joinPaths(parent.path, path);
}
